<template>
  <dialogComp class="dialog-comp" title="" ref="dialog">
    <div
      id="login"
      class="
        g-flexbox g-align-items-center
        m-touch-login
        login
        bounceInDown
        animated
      "
    >
      <div class="m-touch-login__content login">
        <div class="m-login-form">
          <p class="login-desc">参与活动前请先登录（注册）去哪儿账号</p>
          <div class="keepInfo_it">
            <div class="keepInfo_it_cont mobile-box">
              <input
                id="mobile"
                ref="mobile"
                v-model="params.mobile"
                class="input"
                placeholder="输入手机号"
                maxlength="11"
                value=""
              />
            </div>
          </div>
          <div
            v-if="isNeedCaptcha"
            class="login-box-item smscode_box g-flexbox"
          >
            <input
              target="submitLogin"
              v-model="params.vcode"
              type="text"
              placeholder="请输入图片验证码"
              maxlength="6"
              class="g-flex input smscode"
            />
            <img class="btn btn-verification imgCode" :src="imgUrl" />
          </div>
          <div class="g-flexbox smscode_box">
            <input
              v-model="params.smscode"
              class="g-flex input smscode"
              placeholder="请输入验证码"
              maxlength="6"
              value=""
            />
            <button
              :disabled="startTimer"
              @click="getCode"
              type="button"
              class="btn btn-verification"
              :style="
                startTimer
                  ? 'background: rgb(189, 189, 189);'
                  : 'background: #000000;'
              "
            >
              <span
                :style="
                  startTimer
                    ? 'color: rgb(255, 255, 255);'
                    : 'color:rgb(255, 255, 255)'
                "
                >{{ startTimer ? seconds : '获取验证码' }}</span
              >
            </button>
          </div>
          <mt-button @click="userLogin" type="primary">确定</mt-button>
        </div>
      </div>
    </div>
  </dialogComp>
</template>
<script>
import Vue from 'vue';
import dialogComp from '@/components/dialog/index.vue';
import { Button } from 'mint-ui';
import store from '@/store/index';
require('@/utils/hybird');
export default Vue.extend({
  components: {
    dialogComp,
    'mt-button': Button,
  },
  data() {
    return {
      visible: true,
      isNeedCaptcha: false,
      imgUrl: '',
      mobileInput: null,
      startTimer: false,
      instance: null,
      seconds: 60,
      params: {
        mobile: '',
        vcode: '',
        smscode: '',
      },
    };
  },
  methods: {
    user() {
      this.$refs.dialog.close();
    },
    show() {
      this.$nextTick(() => {
        this.$refs.dialog.show();
      });

      this.$nextTick(() => {
        setTimeout(() => {
          this.getUcapi(ucAPI);
        }, 1600);
      });
    },
    checkTel() {
      var reg = /^1[0-9]\d{9}$/,
        value = this.params.mobile.replace(/\s+/g, ''),
        boolTel = reg.test(value);
      if (!boolTel) {
        this.$dialog.alert({
          message: '手机号码格式不正确',
        });
      }
      return boolTel;
    },
    getSmsCodeSuccess(data) {
      this.startTimer = true;

      this.timer = setInterval(() => {
        // let {onFinish} = this.props;

        if (this.seconds <= 0) {
          clearInterval(this.timer);
          this.seconds = 60;
          this.startTimer = false;
        } else {
          this.seconds = this.seconds - 1;
        }
      }, 1000);
    },
    getCode() {
      var boolTel = this.checkTel(),
        optionSms = {
          mobile: this.params.mobile,
          captcha: this.params.vcode,
          onsuccess: this.getSmsCodeSuccess.bind(this),
          //this.getSmsCodeSuccess.bind(this),
          onfail: this.getSmsCodeFail.bind(this),
        };

      if (boolTel) {
        this.instance.sendSMSCode(optionSms);
        //this.getSmsCodeSuccess();
      } else {
        return;
      }
    },
    userLogin(done) {
      if (this.params.mobile.length == 11) {
        var optionLogin = {
          mobile: this.params.mobile,
          smscode: this.params.smscode,
          captcha: this.params.vcode,
          onsuccess: this.loginSuccess.bind(this),
          onfail: this.loginFail.bind(this),
        };
        this.instance.login(optionLogin);
      } else {
        this.$dialog.alert({
          message: '手机号码格式不正确',
        });
        return;
      }
    },
    //登录失败回调
    loginFail(data) {
      //   uni.showToast({
      //     icon: "none",
      //     title: data.errmsg
      //   });
      this.$dialog.alert({
        message: data.errmsg,
      });
    },
    //登陆成功回调
    loginSuccess() {
      var params = { phoneNo: this.params.mobile };
      store.commit('SET_LOGINSTATE', true);
      this.successCallback();
      this.user();
    },
    successCallback() {},
    //获取验证码失败回调
    getSmsCodeFail(data) {
      //重置timer
      this.seconds = 60;
      this.startTimer = false;
      this.$dialog.alert({
        message: data.errmsg,
      });
      clearInterval(this.timer);
      this.timer = null;
    },
    //初始化ucapi
    getUcapi(ucApi) {
      this.mobileInput = this.$refs.mobile;
      let self = this;
      let option = {
        source: 'dmf',
        origin: 'dmf_tmc',
        mobileInput: this.mobileInput,
        registerAuto: true,
        //登录成功后是否同步登录态到大客户端
        syncLoginStatus: true,
        //绑定失败是否不清除cookie，默认为false （即默认清除）
        platform: 'flight_tarvel_hy',
        noclear: true,
      };

      this.instance = ucAPI.quickLogin.create(option);
      this.instance.on('needShowCaptcha', () => {
        this.isNeedCaptcha = true;
        this.imgUrl = self.instance.getCaptchaUrl();
      });
      this.instance.on('needHideCaptcha', () => {
        this.isNeedCaptcha = false;
      });
    },
    initLogin() {},
  },
  watch: {
    value(val, oldVal) {
      if (val) {
        setTimeout(() => {
          this.getUcapi(ucAPI);
        }, 1000);
      }
    },
  },
});
</script>

<style lang="less" scoped="true">
.m-touch-login {
  width: 100%;
  min-height: 278px;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}
.dialog-comp {
  /deep/ .popup_box {
    background: url(https://source.qunarzz.com/site/images/wns/20220803-shijianchen-dialog-bg.png)
      no-repeat;
    background-size: 100% 100%;
  }
}

.m-touch-login__close {
  position: absolute;
  left: 50%;
  bottom: -30px;
  font-size: 35px;
  color: #fff;
  margin-left: -21px;
  width: 42px;
}
input {
  font-size: 15px;
}
input::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: #6f7271;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 适配火狐 */
  color: #6f7271;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ 适配火狐 */
  color: #6f7271;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+  适配ie*/
  color: #6f7271;
}
.m-touch-login__content.login {
  width: 350px;
  padding: 20px;
  .m-login-form {
    padding: 6px 0 0;
  }
}
.mobile-box {
  width: 100%;
  input {
    width: calc(100% - 40px);
  }
  &:before {
    content: '';
    display: block;
    width: 40px;
    background: url(https://picbed.qunarzz.com/83a8cf39d0438436d3c3d91cc461a055.png)
      no-repeat;
    background-size: auto 100%;
    height: 45px;
  }
}

.g-flexbox {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.g-flex {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  width: 0.1px;
}

.m-touch-login .m-login-form .btn-verification {
  flex: 1;
  background-color: #ebf9ff;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.m-login-form .btn-verification {
  width: 115px;
  margin-left: 10px;
  background: #00bcd4;
}
.m-login-form .btn {
  display: inline-block;
  height: 43px;
  line-height: 43px;
  text-align: center;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
}
.login-desc {
  font-size: 15px;
  color: #030303;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 26px;
  font-weight: bold;
}

.m-login-form /deep/ .mint-button--primary {
  background-color: #d52631;
  border-radius: 0;
  display: block;
  width: 100%;
  margin-left: auto;
  margin-top: 16px;
  height: 47px;
  letter-spacing: 10px;
  margin-right: auto;
}
.dialog_tit {
  position: relative;
  bottom: -2px;
}
.login-box-item {
  margin-bottom: 10px;
}
.dg-fade {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  -webkit-user-select: none;
  background: rgba(0, 0, 0, 0.7);
}

.animated {
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
}

.smscode {
  background-color: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #b9b9b9;
  text-align: left;
  text-indent: 15px;
  height: 43px;
  box-sizing: border-box;
  border-radius: 0;
}

.keepInfo {
  &_box {
    background-size: 100% 100%;
    height: 336px;
    background-repeat: no-repeat;
  }
  &_title {
    font-size: 16px;
    font-family: MF;
    font-weight: 400;
    color: rgba(134, 80, 0, 1);
    line-height: 24px;
    padding-top: 65px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 20px;
    img {
      width: 268px;
    }
  }
  &_ls {
    margin-left: 25px;
    margin-top: 0;
    margin-right: 25px;
    &--item {
      height: 35px;
      line-height: 35px;
      background: rgba(255, 255, 255, 1);
      border: 2px solid rgba(247, 187, 108, 1);
      border-radius: 18px;
      font-size: 13px;
      padding-left: 17px;
      color: rgba(247, 187, 108, 1);
      margin-bottom: 8px;
      font-weight: 600;
      &.active {
        box-shadow: 0px 1px 8px 0px rgba(255, 185, 62, 0.85);
        border: none;
      }
    }
  }
  &_it {
    height: 43px;
    background-color: #fff;
    margin-bottom: 8px;
    line-height: 43px;
    &_desc {
      text-align: right;
      font-size: 11px;
      color: rgba(134, 80, 0, 1);
    }
    &_lf {
      padding-left: 17px;
      padding-right: 17px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      &:after {
        content: '';
        display: block;
        width: 1px;
        height: 20px;
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -10px;
        border-right: 1px solid #ccc;
      }
      color: rgba(247, 187, 108, 1);
      float: left;
      img {
        width: 52px;
      }
    }
    &_cont {
      display: flex;
      align-items: center;
      float: left;
      width: 100%;
      height: 100%;
      border: 1px solid #b9b9b9;
      input {
        outline: none;
        border: none;
        height: 100%;
        text-indent: 15px;
        background-color: transparent;
      }
    }
  }
  &_btn {
    padding-bottom: 10px;
    &_img {
      width: 129px;
      height: 43px;
      background-size: 100% 100%;
      outline: none;
      border: none;
      background-color: transparent;
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-top: 12px;
    }
  }
}
</style>
